import { ModelResource } from './resource';
import { OutreachGroup, OutreachRule, StrategyPrompt } from '../models';
import { indexOf } from '@stuut/common/src/utils';

export type UpdateOutreachRuleData = Partial<Omit<OutreachRule, 'id' | 'group_id'>>;

export class OutreachGroups extends ModelResource<OutreachGroup> {
  model = OutreachGroup;

  resourcePath = 'v1/outreach/groups';

  async createRule(
    groupId: string,
    data: UpdateOutreachRuleData,
    group?: OutreachGroup,
  ): Promise<OutreachRule> {
    if (group && group.id !== groupId) {
      throw Error(`${groupId} does not match provided outreach group with id ${group.id}`);
    }

    return this.api.post(this.path(groupId, 'rules'), { data: data }).then((response) => {
      const rule = OutreachRule.fromJson(response.data);
      if (group) {
        group.rules.push(rule);
      }
      return rule;
    });
  }

  async updateRule(
    rule: OutreachRule,
    data: UpdateOutreachRuleData,
    group?: OutreachGroup,
  ): Promise<OutreachRule> {
    return this.api
      .post(this.path(rule.group_id, 'rules', rule.id), { data: data })
      .then((response) => {
        rule.updateFromJson(response.data);
        if (group) {
          group.rules.push(rule);
        }
        return rule;
      });
  }

  async deleteRule(rule: OutreachRule, group?: OutreachGroup): Promise<any> {
    return this.api.delete(this.path(rule.group_id, 'rules', rule.id)).then((response) => {
      if (group) {
        const idx = indexOf(group.rules, (r: OutreachRule) => rule.id === r.id);
        if (idx !== -1) group.rules.splice(idx, 1);
      }
    });
  }

  async updatePrompt(group: OutreachGroup, content?: string): Promise<any> {
    return this.api.post(this.path(group.id, 'prompts'), { data: { content } }).then((response) => {
      group.current_prompt = StrategyPrompt.fromJson(response.data);
    });
  }
}
